import { Transition, TransitionChild } from '@headlessui/react';
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { Fragment, type ReactElement, type ReactNode, useState } from 'react';

interface TooltipProps {
    children: ReactElement;
    message?: ReactNode;
}

function Tooltip({ children, message }: TooltipProps) {
    const [
        hover,
        setHover,
    ] = useState(false);

    if (!message) {
        return children;
    }

    return (
        <div className='relative'>
            <div
                className='flex items-center mt-1 text-sm font-medium text-foreground cursor-pointer hover:text-muted-foreground'
                onMouseEnter={ () => {
                    return setHover(true);
                } }
                onMouseLeave={ () => {
                    return setHover(false);
                } }>
                {children}
                <InformationCircleIcon className='w-4 h-4 ml-2 text-success' />
            </div>
            <Transition as={ Fragment } show={ hover }>
                <div className='absolute z-50 bottom-0 shadow-lg inline-block w-64 px-4 py-3 mb-10 left-0 text-success-foreground bg-success rounded-lg'>
                    <TransitionChild
                        as={ Fragment }
                        enter='transition ease-out duration-100'
                        enterFrom='opacity-0 transform scale-90'
                        enterTo='opacity-100 transform scale-100'
                        leave='transition ease-in duration-100'
                        leaveFrom='opacity-100 transform scale-100'
                        leaveTo='opacity-0 transform scale-90'
                    >
                        <div className={ 'p-1 text-sm' }>{message}</div>
                    </TransitionChild>
                    <span className='absolute bottom-0 right-0 w-5 h-5 -mb-1 transform rotate-45 bg-success'
                        style={ { left: '20%' } }></span>
                </div>
            </Transition>
        </div>
    );
}

export default Tooltip;
